import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bc3c64b6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3c64b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc3c64b6')) {
      api.createRecord('bc3c64b6', component.options)
    } else {
      api.reload('bc3c64b6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=bc3c64b6&scoped=true", function () {
      api.rerender('bc3c64b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/automaticSortings/getSortCode/index.vue"
export default component.exports